import {AbstractModel} from "./abstract-model";

export class Country extends AbstractModel {
  isoCode: string | null = null;
  name: string | null = null;

  override toString(): string {
    return this.name ?? '';
  }

  get flagEmoji(): string {
    return Country.getFlagEmoji(this.isoCode);
  }

  static getFlagEmoji(isoCode: string | null): string {
    if (!isoCode) {
      return '';
    }

    const codePoints = [...isoCode.toUpperCase()].map(char => 127397 + char.charCodeAt(0));

    return String.fromCodePoint(...codePoints);
  }

}
